module.exports = __webpack_public_path__ + "static/img/6.79ce72c8.jpg";